export default __webpack_public_path__ + "static/media/poojan.0a59823a.jpg";